
import { defineComponent, computed, onMounted, reactive, ref } from 'vue'
import dayjs from 'dayjs'
import { useStore } from '../store/index'
import UserSelector from '../components/UserSelector.vue'
import useFilterSearch from '../hooks/useFilterSearch'
import { ElForm } from 'element-plus'
type FormInstance = InstanceType<typeof ElForm>
export default defineComponent({
  name: 'Token',
  components: {
    UserSelector
  },
  setup() {
    const store = useStore()
    const count = computed(() => store.state.token.count)
    const balances = computed(() => store.state.token.data.map(token => {
      token.createdAt = dayjs(token.createdAt).format('YYYY-MM-DD HH:mm') 
      token.updatedAt = dayjs(token.updatedAt).format('YYYY-MM-DD HH:mm')
      return token      
    }))
    const isLoading = computed(() => store.getters.isLoading)
    const ruleFormRef = ref<FormInstance>()

    const searchRules = reactive({
      type: [
        {
          required: true,
          message: '请输入搜索类型',
          trigger: 'change',
        },
      ],
      value: [
        {
          required: true,
          message: '请输入搜索值',
          trigger: 'blur',
        },        
      ]
    })
    const { 
      currentPage,
      PAGE_SIZE,
      searchForm,
      searchTriggered,
      performGetList,
      resetValues,
      onSort
    } = useFilterSearch('getTokenAdmin')
    const onSearch = () => {
      if (!ruleFormRef.value) return
      ruleFormRef.value.validate(async (valid) => {
        if (valid || (searchForm.dateRange && !valid)) {
          if (ruleFormRef.value) {
            ruleFormRef.value.clearValidate('type')
            ruleFormRef.value.clearValidate('value')
          }
          searchTriggered.value = true
          currentPage.value = 1
          await performGetList()
        } else {
          return false
        }
      })
    }
    const resetSearch = () => {
      if (!ruleFormRef.value) return
      searchForm.dateRange = ''
      ruleFormRef.value.resetFields()
      resetValues()
    }
    const onResearch = async () => {
      // reset search
      resetSearch()
      await performGetList()
    }
    const onPageChange = async () => {
      console.log(currentPage.value)
      await performGetList()
    }
    onMounted(async () => { 
      store.dispatch('getTokenAdmin', { searchParams: { currentPage: 1, pageSize: PAGE_SIZE }})
    })
    return {
      count,
      balances,
      currentPage,
      searchRules,
      searchForm,
      PAGE_SIZE,
      onPageChange,
      isLoading,
      ruleFormRef,
      onResearch,
      onSearch,
      onSort,
      searchTriggered,
      // transOrders
    }
  }
});
